export default {
  notFound: 'Page not found',
  NewPageAdded: 'New page added',
  PageUpdated: 'Page updated',
  PageRemoved: 'Page removed',
  ViewPage: 'View page'
}
